var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"md-toggle-icon",on:{"click":_vm.toggleClick}},_vm.$listeners),[_c('font-awesome-icon',{attrs:{"icon":_vm.toggleEye,"fixed-width":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }